import React from "react";
import trophy from "./images/illustration/icon-sport-1.png";
import trophy1 from "./images/illustration/icon-sport-3.png";
import trophy2 from "./images/illustration/icon-sport-2.png";
import trophy3 from "./images/illustration/about-img-1.jpg";
import trophy4 from "./images/illustration/gym-img-1.jpg";
import trophy5 from "./images/background/coaches-img-2.png";
import trophy6 from "./images/background/video-img-1.jpg";
import img1 from "./images/illustration/brand-1.png";
import img2 from "./images/illustration/brand-2.png";
import img3 from "./images/illustration/brand-3.png";
import img4 from "./images/illustration/brand-4.png";
import trophy7 from "./images/illustration/team-member-1.jpg";
import trophy8 from "./images/illustration/team-member-2.jpg";
import trophy9 from "./images/illustration/team-member-3.jpg";
import trophy10 from "./images/illustration/team-member-4.jpg";
import trophy11 from "./images/illustration/team-member-6.jpg";
import trophy12 from "./images/illustration/instagram-img-1.jpg";
import trophy13 from "./images/illustration/instagram-img-2.jpg";
import trophy14 from "./images/illustration/instagram-img-3.jpg";
import trophy15 from "./images/illustration/instagram-img-4.jpg";

const About = () => {
  return (
    <>
      <div className="container-fluid" id="bg_image g-0">
        <div className="row g-0">
          <div className="col-12">
            <h2 className="text-white fs-1 fw-bold heading">
              <span className="text-warning">About</span> Us
            </h2>
            <p className="fw-bold text-white fs-1">Back Home</p>
          </div>
        </div>
      </div>
      <div className="bottom">
        <div className="row mt-4 text-center g-0">
          <div className="col-12 ">
            <h1 className="fw-bold heading fs-3">WHY TO CHOOSE FITEL</h1>
            <p className="fw-bold">
              Pharetra at suspendisse neque ipsum a, id viverra vel aliquam.
              Libero sem morbi et dis montes, <br /> varius habitasse
              adipiscing. Gravida hendrerit vitae nulla fermentum imperdiet
              pretium lacus erat. Cras facilisis <br /> risus sit turpis ut sed
              sit tellus.
            </p>
          </div>
          <div className="row align-items-center g-0">
            <div className="col-12 col-md-6 col-xl-6">
              <div className="icons_section my-4 d-flex justify-content-center align-items-center">
                <img
                  src={trophy}
                  className="img-fluid about_image me-4"
                  alt="img not found"
                />
                <div className="inner_section g-0">
                  <h2 className="fw-bold fs-3">Individual Nutrition Plans</h2>
                  <p className="fw-bold">
                    Diam parturient adipiscing aliquam duis ornare risus,
                    interdum
                  </p>
                </div>
              </div>
              <div className="icons_section my-4 d-flex justify-content-center align-items-center">
                <img
                  src={trophy1}
                  className="img-fluid about_image me-4"
                  alt="img not found"
                />
                <div className="inner_section">
                  <h2 className="fw-bold">Individual Nutrition Plans</h2>
                  <p className="fw-bold">
                    Diam parturient adipiscing aliquam duis ornare risus,
                    interdum
                  </p>
                </div>
              </div>
              <div className="icons_section my-4 d-flex justify-content-center align-items-center">
                <img
                  src={trophy2}
                  className="img-fluid about_image me-4"
                  alt="img not found"
                />
                <div className="inner_section">
                  <h2 className="fw-bold">Individual Nutrition Plans</h2>
                  <p className="fw-bold">
                    Diam parturient <br />
                    adipiscing aliquam duis ornare risus, interdum
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-6">
              <img
                src={trophy3}
                className="img-fluid rounded-4"
                alt="img not found"
              />
            </div>
          </div>
          <div
            className="row mx-auto text-center"
            style={{ marginTop: "80px" }}
          >
            <div className="col-12">
              <h2 className="heading fw-bold mb-3 fs-2">ABOUT OUR STUDIO</h2>
              <img
                src={trophy4}
                className="img-fluid rounded-4 w-75 img-fluid"
                alt="img not found"
              />
            </div>
          </div>
          <div className="row mt-5 justify-content-center align-items-center">
            <div className="col-12 col-md-6 col-xl-4">
              <p className="fs-5 fw-bold">
                Diam parturient adipiscing aliquam duis ornare risus, interdum.
                Metus tristique amet porttitor est et duis ac ornare. Bibendum
                proin ornare curabitur congue. Nunc nibh semper congue dictum
                risus orc
              </p>
            </div>
            <div className="col-12 text-center col-md-6 col-xl-4">
              <p className="duplicate_button mx-auto fs-2 fw-bold py-3 px-4 rounded-4 bg-warning w-50 d-flex justify-content-center align-items-center">
                10+ year
              </p>
            </div>
            <div className="col-12 fw-bold fs-5 col-md-6 col-xl-4">
              <p>
                Of Successful Work <br /> & Experience Of Training
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 col-xl-4 py-5">
            <img src={trophy5} alt="image not found" className="w-75" />
          </div>
          <div className="col-12 col-md-6 col-xl-4 py-5 me-5">
            <h2 className="fs-5 fw-bold">Convenient Location & Schedule</h2>
            <p className="fs-5">
              Diam parturient adipiscing aliquam duis ornare risus, interdum.
              Metus amet potot.
            </p>
          </div>
          <div className="col-12 col-md-6 col-xl-3 py-5">
            <h2 className="fs-5 fw-bold ">
              Individual Training Programs For All
            </h2>
            <p>
              Aliquet blandit euismod aliquet ac turpis. Ac lorem fermentum nisl
              faucibus volutpat a.
            </p>
          </div>
        </div>
      </div>
      <div className="row g-0">
        <div className="col-12 py-5 ">
          <h2 className="text-center fw-bold fw-bold headingfs-3">
            WATCH HOW WE WORK
          </h2>
          <img src={trophy6} alt="image not found" className="img-fluid" />
        </div>
      </div>
      <div className="row  bg-dark text-white">
        <div className="col-xl-3 col-12 col-md-6">
          <img
            src={img1}
            alt="image not found"
            className="img-fluid w-75 raj"
          />
        </div>
        <div className="col-xl-3 col-12 col-md-6">
          <img
            src={img2}
            alt="image not found"
            className="img-fluid w-75 raj"
          />
        </div>
        <div className="col-xl-3 col-12 col-md-6">
          <img
            src={img3}
            alt="image not found"
            className="img-fluid w-75 raj"
          />
        </div>
        <div className="col-xl-3 col-12 col-md-6">
          <img
            src={img4}
            alt="image not found"
            className="img-fluid w-75 raj"
          />
        </div>
      </div>
      <div className="row  mt-5">
        <div className="col-12">
          <h2 className="text-center fw-bold heading fs-3">OUR BEST COACHES</h2>
        </div>
        <p className="fs-4">
          Diam parturient adipiscing aliquam <br />
          duis ornare risus, interdum. Metus tristique amet porttitor est et
          duis ac ornare<br></br>. Bibendum proin ornare curabitur congue. Nunc
          nib.
        </p>
      </div>
      <div className="row g-0">
        <div className="col-12 col-md-3">
          <img src={trophy7} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-12 col-md-3">
          <img src={trophy8} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-12 col-md-3">
          <img src={trophy9} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-12 col-md-3">
          <img src={trophy10} alt="image not found" className="img-fluid" />
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12">
          <h2 className="fw-bold  heading fs-3 text-center">
            TESTIMONIALS FROM CUSTOMERS
          </h2>
        </div>
        <div className="col-12 col-md-6 mt-4 ">
          <p className="mx-auto ms-4 fw-bold ">
            "TINCIDUNT CONGUE TURPIS NISL,VEL ALIQUET <br />
            SAGITTIS,PURUS,CONSEQUAT.LEO VEL AENEAN LECTUS"
          </p>
          <img
            src={trophy11}
            alt="image not found"
            className="img-fluid w-25 ms-5"
          />
        </div>
        <div className="col-12 col-md-6 mt-4">
          <p className="fw-bold ms-5">
            "NULLA MOLESTIE ALIQUAM DICTUM SUSPENDISSE VULPUTATE <br /> DIS
            FACILISI NIBI VITAE TORTOR,NOR DOLOR".
          </p>
          <img
            src={trophy10}
            alt="image not found"
            className="img-fluid w-25"
          />
        </div>
      </div>
      <div className="row g-0">
        <div className="col-12">
          <h1 className="text-center fw-bold fw-bold heading fs-2 mt-5">
            WORKING HOURS
          </h1>
          <p className=" mt-5 text-center mx-auto fs-5 mt-5">
            Augue ornare felis, neque adipiscing vitae,
            <br /> elementum egestas quam id. Cum odio.
          </p>
        </div>
        <div className="col-12 md-6 px-5 mt-5" id="Demo7">
          <p className=" duplicate_button mx-auto fs-2 fw-bold  rounded-4 bg-warning w-25 d-flex justify-content-center align-items-center">
            WEEKDAYS: 6AM-10PM
          </p>
        </div>
        {/* <div className="col-12 md-6 px-5" id="Demo8">
          <p className="duplicate_button mx-auto fs-2 fw-bold py-3 px-3 ms-5 me-5  rounded bg-info w-25 d-flex justify-content-center align-items-center">
            {" "}
          </p>
        </div> */}
        <div className="col-12 text-center">
          <p className="duplicate_button btn btn-outline-danger" type="submit">
            CONTACT US
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <h2 className="text-center  fw-bold heading fs-3 mt-5">
            SUBSCRIBE TO OUR INSTAGRAM
          </h2>
        </div>
        <div className="col-xl-3 col-12 col-md-6 g-0">
          <img src={trophy12} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-xl-3 col-12 col-md-6">
          <img src={trophy13} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-xl-3 col-12 col-md-6">
          <img src={trophy14} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-xl-3 col-12 col-md-6">
          <img src={trophy15} alt="image not found" className="img-fluid" />
        </div>
      </div>
      <div className="row mt-5 g-0">
        <div className="col-12"></div>
        <div class="input-group mb-3 w-25 mx-auto">
          <input
            type="text"
            class="form-control"
            placeholder="Recipient's username"
            aria-label="Recipient's username"
            aria-describedby="button-addon2"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            id="button-addon2"
          >
            Submit
          </button>
        </div>
      </div>
      <div className="row g-0 bg-dark text-white g-0">
        <div className="col-12 col-md-6 col-xl-3 mt-5">
          <h1>WoxFit</h1>
          <p>
            {" "}
            Parturient porttitor quam mattis ipsum imperdiet habitasse orci.
            Risus integer.
          </p>
          <div className="icons">
            <i class="fab fs-3  fa-instagram"></i>
            <i class="fab fs-3  fa-twitter"></i>
            <i class="fab fs-3  fa-facebook"></i>
          </div>
        </div>
        <div className="col-12 col-md-6 col-xl-3 mt-5 g-0">
          <h1>About</h1>
          <p className="">About us</p>
          <p className="">Blog</p>
          <p className="">Careers</p>
          <p className="">Jobs</p>
        </div>
        <div className="col-12 col-md-6 col-xl-3 mt-5 g-0">
          <h1>Services</h1>
          <p className="box10">How we work</p>
          <p className="box10">Portfolio</p>
          <p className="box10">Pricing</p>
          <p className="box10">More</p>
        </div>
        <div className="col-12 col-md-6 col-xl-3 mt-5">
          <h1>Support</h1>
          <p>Contact us</p>
          <p>online chat</p>
          <p>Whatsapp</p>
          <p>Telegram</p>
        </div>
      </div>
    </>
  );
};

export default About;
